<template>
    <div>
        <td-dialog :title="title" :before-close="roleDialogClose" :visible.sync="dialogRoleVisible" :width="dialogWidth + 'px'" :close-on-click-modal="false" :close-on-press-escape="false" top="10vh">
            <el-form :model="formRoleInfo" ref="formRoleInfo" :label-width="formLabelWidth + 'px'" :rules="rules">
                <el-row>
                    <el-col :span="13">
                        <el-form-item :label="$t('common.ROLENAME')" prop="roleName">
                            <td-input v-model="formRoleInfo.roleName" :disabled="isOrgType" :maxlength="10"></td-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item :label="$t('common.ROLE_TYPE')" prop="roleType">
                            <td-select
                                @change="onChangeRoleType"
                                v-model="formRoleInfo.roleType"
                                :placeholder="$t('common.PLEASE_SELECT')"
                                disabled="true"
                                :options="roleTypeList"
                                keys="iTypeId"
                                text="sName"
                            >
                            </td-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="13">
                        <el-form-item :label="$t('role.VALIDITY_START')" prop="startTime">
                            <td-date-time
                                :editable="false"
                                v-model="formRoleInfo.startTime"
                                type="date"
                                :pickerOptions="pickerBeginDateBefore"
                                :placeholder="$t('common.START_TIME')"
                                :clearable="false"
                            ></td-date-time>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item :label="$t('common.UNTIL')" prop="endTime">
                            <td-date-time
                                :editable="false"
                                v-model="formRoleInfo.endTime"
                                type="date"
                                :pickerOptions="pickerBeginDateAfter"
                                :placeholder="$t('common.END_TIME')"
                                :clearable="false"
                            ></td-date-time>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="isDoorType">
                    <el-form-item :label="$t('role.THROUGH_CONTROL')" style="margin-left:-105px">
                        <td-checkbox v-model="formRoleInfo.isPasswordNeeded" :trueLabel="1" :falseLabel="0">{{ $t('role.PASSWORD_NEEDED') }}</td-checkbox>
                        <td-checkbox v-model="formRoleInfo.isAntiSneak" :trueLabel="1" :falseLabel="0">{{ $t('role.ANTI_SNEAK') }}</td-checkbox>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="93px" :label="$t('common.ROLEDESCRIPTION')" prop="description">
                            <td-input type="textarea" v-model="formRoleInfo.description" :maxlength="100" width="100%"></td-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px">
                    <el-tabs v-model="activeName" @tab-click="onTabClick" ref="authTabs" :inline="true" type="card">
                        <el-tab-pane v-show="isMenuManager" :label="$t('role.MENU_AUTH_SET')" :model="menuAuth" name="menuAuth" :key="'menuAuth'" class="tree_aollapse_node">
                            <td-tree
                                height="725px"
                                :invertBoxShow="true"
                                :lazyloading="false"
                                :draggable="false"
                                :showBox="true"
                                :treeList="this.menuList"
                                :defaultProps="defaultProps"
                                :imgloading="true"
                                nodeKey="menuId"
                                ref="menuTree"
                                @customNode="customNode"
                                @check="check"
                                @invertChange="invertChange"
                            >
                            </td-tree>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('role.AUTH_SMALL_CHANGE')" :model="authTriming" name="authTriming" :key="'authTriming'">
                            <p style="color:red;fontSize:11px;padding-left:20px">{{ $t('role.AUTH_SMALL_CHANGE_NOTE') }}</p>
                            <el-collapse v-loading="collapseloading" :element-loading-text="$t('role.COLLPASE_LOADING')">
                                <el-collapse-item v-show="isAllowAccess" style="padding-bottom: 0px">
                                    <template slot="title" style="padding-left:20px">
                                        <p style="padding-left:20px">{{ $t('role.ALLOW_ACCESS') + transferTitle }}</p>
                                    </template>
                                    <div style="padding-left:45px;padding-top: 20px">
                                        <TdTransferList
                                            ref="allowTransfer"
                                            :roleType="formRoleInfo.roleType"
                                            :allowResGroup="allowResGroup"
                                            :permissionStr="permissionStr"
                                            :interfaceName="interfaceName"
                                            :props="transferProps"
                                            :value="allowAccessData"
                                            :previewImageUrl="previewImageUrl"
                                            :orgImgName="orgImgName"
                                            :areaImgName="areaImgName"
                                            :resImgName="resImgName"
                                            @onclickSet="onclickSet"
                                            @deleteRightData="deleteRightData"
                                            :authTrimingMap="authTrimingMap"
                                            :isShowSet="true"
                                        ></TdTransferList>
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item v-show="isUnAllowAccess">
                                    <template slot="title" style="padding-left:20px">
                                        <p style="padding-left:20px">{{ $t('role.UN_ALLOW_ACCESS') + transferTitle }}</p>
                                    </template>
                                    <div style="padding-left:45px">
                                        <TdTransferList
                                            ref="unAllowTransfer"
                                            :allowResGroup="false"
                                            :permissionStr="permissionStr"
                                            :interfaceName="interfaceName"
                                            :props="transferProps"
                                            :value="unAllowAccessData"
                                            :previewImageUrl="previewImageUrl"
                                            :orgImgName="orgImgName"
                                            :areaImgName="areaImgName"
                                            :resImgName="resImgName"
                                            :authTrimingMap="authTrimingMap"
                                            :isShowSet="false"
                                        ></TdTransferList>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>
            </el-form>
            <el-row>
                <dialogSelectAuth
                    ref="selectAuth"
                    v-if="selectAuthVisible"
                    :clickCollapse="clickCollapse"
                    :selectAuthVisible="selectAuthVisible"
                    :selectAuthMap="selectAuthMap"
                    :menuId="currentMenuId"
                    @getCheckedStatus="getCheckedStatus"
                    @getCheckedAuth="getCheckedAuth"
                    @setCheckAllBtnStatus="setCheckAllBtnStatus"
                    @saveSelectedAuth="saveSelectedAuth"
                    @closeSelectAuth="closeSelectAuth"
                    @deleteResByMenuId="deleteResByMenuId"
                ></dialogSelectAuth>
                <dialogAuthTriming
                    ref="resAuthTriming"
                    v-if="dialogAuthTrimingVisible"
                    :dialogAuthTrimingVisible="dialogAuthTrimingVisible"
                    @closeAuthTriming="closeAuthTriming"
                    @saveAuthTriming="saveAuthTriming"
                    :checkgroupData="checkgroupData"
                    :authTrimingMap="authTrimingMap"
                    :authCheckedList="authCheckedList"
                    :resTrimingData="resTrimingData"
                ></dialogAuthTriming>
            </el-row>
            <span slot="footer"
                ><td-button type="primary" @click="submitForm('formRoleInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
                <td-button type="button" @click.native="roleDialogClose">{{ $t('common.CANCEL') }}</td-button>
            </span>
        </td-dialog>
    </div>
</template>
<script>
import resourceApi from '../assets/api.js';
import TdTransferList from './TdTransferRes.vue';
import dialogSelectAuth from './dialogSelectAuth.vue';
import dialogAuthTriming from './dialogAuthTriming.vue';
export default {
    // 初始化渲染
    components: {
        TdTransferList,
        dialogSelectAuth,
        dialogAuthTriming
    },
    props: ['title', 'dialogRoleVisible', 'editItem', 'isAddData', 'sysFlg', 'sysList', 'orgTreeUrl', 'doorTreeUrl', 'roleTypeList', 'authTrimingMap', 'checkedAuthTriming', 'currentRoleType'],
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    created() {
        // this.getMenuUrl();
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        } else {
            this.formRoleInfo.roleType = this.currentRoleType;
            this.collapseloading = false;
        }
        let roleResData = [];
        let param = {
            // sysFlg: this.sysFlg
        };
        resourceApi.getMenuResTypeMap(JSON.stringify(param), response => {
            this.getMenuUrl();
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('role/getAllRoleResType', response.data.statusMessage);
                return;
            }
            //初始化控件起始时间
            if (this.isAddData) {
                let nowDate = new Date(response.headers.date);
                nowDate.setHours(0);
                nowDate.setMinutes(0);
                nowDate.setSeconds(0);
                this.formRoleInfo.startTime = nowDate;
            }
            roleResData = response.data.content;
            //缓存权限资源map
            for (let key in roleResData) {
                var val = roleResData[key];
                // 将权限添加到具体资源
                let res = this.transData2(val, 'resId', 'sParentId', 'authId', 'authTypes');
                // 将json转化为带父子结构
                let result = this.transData1(res, 'resId', 'sParentId', 'authId', 'children');
                if (window.app.sPlatformFlg != 'pg') {
                    delete result.pgdata;
                }
                this.menuAuthMap.set(key, result);
            }
            if (!this.isAddData) {
                let checkAuth = [];
                resourceApi.listRoleResAuth(JSON.stringify(this.formRoleInfo), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/auth/role/getCheckedAuth', response.data.statusMessage);
                        return;
                    }
                    checkAuth = response.data.content;
                    this.initCheckStateMap(this.menuAuthMap, checkAuth);
                    this.menuCheckedAuthList = checkAuth;
                });
            }
            this.getAllResAuthMap(this.menuAuthMap);
        });
    },
    mounted() {
        this.$nextTick(() => {
            // this.initElement();
            let flag = false;
            if (!this.isAddData) {
                flag = true;
            }
            this.onChangeRoleType(this.formRoleInfo.roleType, flag);
        });
        if (!this.isAddData) {
            this.$nextTick(function() {
                // this.onChangeRoleType(this.editItem.roleType, true);
                this.roleTypeList.forEach(element => {
                    if (element.iTypeId == this.editItem.roleType) {
                        this.role = element;
                    }
                });
                //查询已保存的资源
                this.sRoleId = this.editItem.roleId;
                this.sTypeService = this.role.sTypeService;
                this.sResNameApi = this.role.sResNameApi;
                let param = {
                    sRoleId: this.sRoleId,
                    sTypeService: this.sTypeService,
                    sResNameApi: this.sResNameApi
                };
                if (this.isAllowAccess) {
                    this.getUseResInfo(param);
                }
                if (this.isUnAllowAccess) {
                    this.getUnUseResInfo();
                }
            });
        }
        if (this.isAddData) {
            this.roleTypeList.forEach((type, index) => {
                if (type.iTypeId == 1) {
                    this.roleTypeList.splice(index, 1);
                }
            });
            // this.$nextTick(function() {
            //     this.onChangeRoleType(0);
            // });
        }
    },
    // 监听时间
    watch: {
        ['formRoleInfo.startTime'](val) {
            let dateVal = this.formRoleInfo.endTime;
            if (dateVal && val && new Date(val).getTime() > new Date(dateVal).getTime()) {
                this.formRoleInfo.endTime = val;
            }
        },
        ['formRoleInfo.endTime'](val) {
            let dateVal = this.formRoleInfo.startTime;
            if (dateVal && val && new Date(dateVal).getTime() > new Date(val).getTime()) {
                this.formRoleInfo.startTime = val;
            }
        },
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.dialogWidth = 730 + (Number(newVal) == 14 ? 0 : 2 * Number(newVal));
                this.formLabelWidth = 95 + (Number(newVal) == 14 ? 0 : Number(newVal));
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    // 定义变量
    data() {
        let validateRoleName = (rule, value, callback) => {
            let reg = new RegExp(this.$regex.ROLECAPTION_RULE);
            if (!reg.test(value)) {
                callback(this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL'));
            }
            let roleId = '';
            if (!this.isAddData) {
                roleId = this.formRoleInfo.roleId;
            }
            let param = {
                roleName: value,
                sysID: this.sysFlg,
                id: roleId
            };
            resourceApi.getRoleInfoByName(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleInfoByName', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('error.ERROR_ROLE_NAME_REPEAT'));
                } else {
                    callback();
                }
            });
        };
        return {
            dialogWidth: '730',
            /* 存储当前节点以及子节点数据 */
            allNodeMap: new Map(),
            /* 存储当前节点以及子节点id数组 */
            allNodeIdList: [],
            activeName: 'menuAuth',
            dialogAuthTrimingVisible: false,
            checkgroupData: [],
            //选中微调资源操作集合
            authCheckedList: [],
            //选中的微调资源信息
            resTrimingData: {},
            //资源微调数据
            rightDataFinetune: {},
            //菜单中选中的操作权限 （要在权限微调弹出框中显示）
            menuCheckedAuthList: [],
            //缓存权限资源集合
            menuAuthMap: new Map(),
            selectAuthMap: new Map(),
            currentMenuId: '',
            selectAuthVisible: false,
            clickCollapse: [],
            initObject: {},
            currenntMenuList: [],
            collapseloading: true,
            //资源穿梭框数据
            transferProps: {
                key: 'sResId',
                label: 'sResName',
                resType: 'sResType',
                permissionStr: 'sPermissionStr'
            },
            previewImageUrl: 'auth',
            orgImgName: 'org.png',
            areaImgName: 'area.png',
            resImgName: 'devCamera.png',
            transferTitle: '',
            permissionStr: 'org',
            role: '', //当前角色
            sTypeService: '',
            sResNameApi: '',
            sRoleId: '',
            sResGroupApi: '', //分组资源查询接口
            interfaceName: {
                //左侧框查询接口
                query: '/OrgManagerController/findTree',
                search: ''
            },
            useResInterface: '/auth/role/getUseResInfo', //允许访问的资源信息接口
            unUseResInterface: '/auth/role/getUnUseResInfo', //禁止访问的资源信息接口
            allowAccessData: [],
            unAllowAccessData: [],
            isMenuManager: true,
            isAllowAccess: true,
            isUnAllowAccess: true,
            isManageRes: true,
            allowResGroup: false,
            //资源是否显示设置
            isShowset: false,
            // Role表单信息
            hasMenuPermission: true,
            hasOrgPermission: true,
            hasDoorPermission: true,
            pg: true,
            timeScheduleList: [],
            isOrgType: false,
            isDoorType: false,
            formRoleInfo: {
                startTime: new Date(Date.parse('2000-1-1 00:00:00'.replace(/-/g, '/'))),
                endTime: new Date(Date.parse('2199-12-31 23:59:59'.replace(/-/g, '/'))),
                description: '',
                roleName: '',
                roleType: 0,
                roleId: '',
                resId: '',
                isAntiSneak: 0,
                isPasswordNeeded: 0,
                sysFlg: ''
            },
            params: {
                rootCodes: ['BH-0001'],
                currentPage: 1,
                needPage: true,
                pageSize: 50
            },
            doorParams: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                deviceTypeList: [50]
            },
            orgInitFlg: true,
            normalRole: true,
            sCodes: ['BH-0001'],
            checkedList: [],
            checkedResAuthList: [],
            checkedDept: [],
            checkedMenu: [],
            resIdList: [],
            menuList: [],
            hostUrl: '',
            defaultProps: {
                children: 'children',
                id: 'menuId',
                label: 'menuName',
                imgName: 'type'
            },
            defaultProps2: {
                children: 'oopp',
                id: 'menuId',
                label: 'text',
                imgName: 'type'
            },
            defaultDeptProps: {
                parentId: 'parentId',
                children: 'children',
                id: 'id',
                label: 'caption',
                imgName: 'sIcon'
            },
            count: 1,
            menuRoles: [],
            collapseNames: [],
            addState: '',
            formLabelWidth: '95',
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                roleName: [{ required: true, message: this.$t('error.ERROR_ROLE_CAPTION_NULL'), trigger: 'blur' }, { validator: validateRoleName, trigger: 'blur' }],
                roleType: [{ required: true, message: this.$t('roleError.ERROR_ROLE_TYPE_NULL'), trigger: 'blur' }],
                description: [{ min: 1, max: 100, message: this.$t('error.ERROR_URL_MAX_LENGTH'), trigger: 'change' }],
                sPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 100, message: this.$t('error.ERROR_PASSWORD_MAX_LENGTH'), trigger: 'blur' }
                ]
            },
            pickerBeginDateBefore: {
                disabledDate: time => {
                    let dateVal = this.formRoleInfo.endTime;
                    if (dateVal) {
                        return time.getTime() > new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime();
                    }
                }
            },
            pickerBeginDateAfter: {
                disabledDate: time => {
                    let dateVal = this.formRoleInfo.startTime;
                    if (dateVal) {
                        return time.getTime() <= new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime() - 8.64e7;
                    }
                }
            }
        };
    },
    // 定义并实现方法体
    methods: {
        onclickSet(data) {
            if (this.authTrimingMap && data) {
                this.checkgroupData = this.authTrimingMap[data.sPermissionStr];
            }
            let updateCheckedList = this.rightDataFinetune[data.sResId];
            let resType = this.checkgroupData[0].resTypeId;
            //获取菜单中选中的资源权限 (初始化显示在菜单和权限微调中勾选的权限 之后显示用户在权限微调勾选的权限)
            let menuAuthList = this.getCheckMenuAuthList(resType, this.checkgroupData);
            if (this.checkedAuthTriming && !updateCheckedList) {
                if (!this.$util.isArray(this.checkedAuthTriming[data.sResId])) {
                    this.authCheckedList = menuAuthList;
                } else {
                    this.authCheckedList = this.checkedAuthTriming[data.sResId];
                }
            } else {
                this.authCheckedList = updateCheckedList;
            }
            this.resTrimingData = data;
            this.dialogAuthTrimingVisible = true;
        },
        deleteRightData(data) {
            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                if (this.rightDataFinetune[element.sResId]) {
                    this.rightDataFinetune[element.sResId] = null;
                }
                if (this.checkedAuthTriming[element.sResId]) {
                    this.checkedAuthTriming[element.sResId] = null;
                }
            }
        },
        //数组去重合并
        concatDist(arr1, arr2) {
            if (!this.$util.isArray(arr2) || arr2.length == 0) {
                return arr1;
            }
            for (let i = 0; i < arr2.length; i++) {
                const element = arr2[i];
                if (arr1.indexOf(element) == -1) {
                    arr1.push(element);
                }
            }
            return arr1;
        },
        //勾选菜单复现框事件
        check(data, treeObj) {
            let checkMenuIdList = treeObj.checkedKeys;
            checkMenuIdList.forEach(menuId => {
                let resAuthList = this.menuAuthMap.get(menuId);
                if (this.$util.isEmpty(resAuthList)) {
                    return;
                }
                this.checkAllChange(true, resAuthList);
            });
        },
        /**
         * 反选
         * value:boolean 是否勾选
         * checkedList:勾选的checkedList
         */
        invertChange(value, checkedList) {
            checkedList.forEach(menuId => {
                let resAuthList = this.menuAuthMap.get(menuId);
                if (this.$util.isEmpty(resAuthList)) {
                    return;
                }
                this.checkAllChange(true, resAuthList);
            });
        },
        queryChildrenMenu(list, menuId) {
            list.forEach(menu => {
                if (menuId == menu.menuId) {
                    this.currenntMenuList.push(menu.menuId);
                    if (Array.isArray(menu.children) && menu.children.length > 0) {
                        this.queryChildrenMenuList(menu.children);
                    }
                } else {
                    if (menu.children.length > 0) {
                        this.queryChildrenMenu(menu.children, menuId);
                    }
                }
            });
        },
        queryChildrenMenuList(list) {
            list.forEach(menu => {
                this.currenntMenuList.push(menu.menuId);
                if (Array.isArray(menu.children) && menu.children.length > 0) {
                    this.queryChildrenMenuList(menu.children);
                }
            });
        },
        //全选/反选
        checkAllChange(isCheck, list) {
            for (let i in list) {
                let obj = list[i];
                if (isCheck) {
                    obj.checkAll = true;
                    if (!Array.isArray(obj.checkList)) {
                        obj.checkList = [];
                    }
                    if (Array.isArray(obj.authTypes)) {
                        obj.authTypes.forEach(auth => {
                            if (obj.checkList.indexOf(auth.authId) == -1) {
                                obj.checkList.push(auth.authId);
                            }
                        });
                    }
                    if (obj.children.length > 0) {
                        this.checkAllChange(isCheck, obj.children);
                    }
                }
            }
        },
        // 自定义图标
        customNode(val, callback) {
            if (!this.menuAuthMap.get(val.menuId)) {
                return;
            }
            let collection = {
                type: 'tdButton',
                method: 'selectAuth',
                icon: 'iconfont icongongju',
                isLocal: 'true'
            };
            let buttonList = [collection];
            callback(val, buttonList);
        },
        //选择权限资源
        selectAuth(val) {
            this.currentMenuId = val.menuId;
            let currentData = this.menuAuthMap.get(this.currentMenuId);
            //获取当前菜单下的所有权限
            let resultList = this.selectAuthMap.get(this.currentMenuId);
            let addAuthList = this.getChangeAuth(resultList);
            for (let key in currentData) {
                //更新所选菜单下资源权限的选中状态
                this.updateSelectedRes(currentData[key], addAuthList);
            }
            this.selectAuthVisible = true;
            this.clickCollapse = this.$util.clone(currentData);
        },
        //获取该菜单下选中的权限
        getChangeAuth(authIdList) {
            let addAuthList = [];
            this.checkedResAuthList.forEach(now => {
                //新增权限
                if (authIdList.indexOf(now) > -1) {
                    addAuthList.push(now);
                }
            });
            return addAuthList;
        },
        //更新所选菜单下资源权限的选中状态
        updateSelectedRes(value, tempCheckedResAuth) {
            for (let i = 0; i < tempCheckedResAuth.length; i++) {
                let resAuth = tempCheckedResAuth[i];
                let resId = resAuth.split(',')[0];
                if (resId == value.resId && Array.isArray(value.authTypes)) {
                    for (let j = 0; j < value.authTypes.length; j++) {
                        let auth = value.authTypes[j];
                        if (auth.authId == resAuth) {
                            if (!Array.isArray(value.checkList)) {
                                let tempList = [];
                                tempList.push(resAuth);
                                value.checkList = tempList;
                            } else {
                                if (value.checkList.indexOf(resAuth) == -1) {
                                    value.checkList.push(resAuth);
                                }
                            }
                            break;
                        }
                    }
                    if (value.authTypes.length == value.checkList.length) {
                        value.checkAll = true;
                    }
                    let index = tempCheckedResAuth.indexOf(resAuth);
                    if (index > -1) {
                        tempCheckedResAuth.splice(i, 1);
                        --i;
                    }
                }
                if (value.children.length > 0) {
                    let count = 0;
                    value.children.forEach(element => {
                        this.updateSelectedRes(element, tempCheckedResAuth);
                        if (element.checkAll) {
                            ++count;
                        }
                    });
                    if (count == value.children.length) {
                        if ((Array.isArray(value.authTypes) && value.authTypes.length == value.checkList.length) || !Array.isArray(value.authTypes)) {
                            value.checkAll = true;
                        }
                    } else {
                        value.checkAll = false;
                    }
                }
            }
        },
        //保存选中的权限资源
        saveSelectedAuth(val) {
            this.menuAuthMap.set(this.currentMenuId, val);
            //将选中的资源加到checkedResAuthList
            this.checkedResAuthList = [];
            this.getAllCheckedResAuth(this.menuAuthMap);
        },
        //同步删掉其他菜单中的权限资源
        deleteResByMenuId(cancelChecked, repeatMenuList) {
            repeatMenuList.forEach(menuId => {
                let resList = this.menuAuthMap.get(menuId);
                let resId = cancelChecked.split(',')[0];
                this.deleteRes(resList, resId, cancelChecked);
            });
        },
        deleteRes(resList, resId, authId) {
            for (let i in resList) {
                let res = resList[i];
                if (Array.isArray(res.children) && res.children.length > 0) {
                    this.deleteRes(res.children, resId, authId);
                }
                if (Array.isArray(res.checkList)) {
                    let index = res.checkList.indexOf(authId);
                    if (index > -1) {
                        res.checkList.splice(index, 1);
                    }
                    if (Array.isArray(res.authTypes) && res.checkList.length != res.authTypes.length) {
                        res.checkAll = false;
                    }
                }
            }
        },
        //关闭权限选择dialog
        closeSelectAuth() {
            this.selectAuthVisible = false;
        },
        //关闭资源微调dialog
        closeAuthTriming() {
            this.dialogAuthTrimingVisible = false;
        },
        //保存资源微调数据
        saveAuthTriming(data) {
            this.rightDataFinetune = this.$util.clone(this.checkedAuthTriming);
            data.forEach((value, key) => {
                this.rightDataFinetune[key] = value;
            });
            this.checkedAuthTriming = this.$util.clone(this.rightDataFinetune);
        },
        //允许访问的资源信息接口
        getUseResInfo() {
            let param = {
                sRoleId: this.sRoleId,
                sTypeService: this.sTypeService,
                sResNameApi: this.sResNameApi,
                isQueryMenuRes: false
            };
            window.vue.$apiAxios.postRequestBody(this.useResInterface, JSON.stringify(param), response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                    let data = response.data.content;
                    if (data.length > 0) {
                        this.$refs.allowTransfer.initRightListDate(data);
                    }
                } else {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/role/getUseResInfo-----is error', response.data.statusCode);
                }
            });
        },
        //禁止访问的资源信息接口
        getUnUseResInfo() {
            let param = {
                sRoleId: this.sRoleId,
                sTypeService: this.sTypeService,
                sResNameApi: this.sResNameApi,
                isQueryMenuRes: false
            };
            window.vue.$apiAxios.postRequestBody(this.unUseResInterface, JSON.stringify(param), response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                    let data = response.data.content;
                    if (data.length > 0) {
                        this.$refs.unAllowTransfer.initRightListDate(data);
                    }
                } else {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/role/getUnUseResInfo-----is error', response.data.statusCode);
                }
            });
        },
        //树形查询组织返回结果
        queryUrlResponse(response) {
            if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                this.hasOrgPermission = false;
            } else if (this.$util.isEmpty(response.data.content)) {
                this.hasOrgPermission = false;
            }
        },
        //门禁树形查询返回结果
        queryDoorUrlResponse(response) {
            if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                this.hasDoorPermission = false;
            } else if (this.$util.isEmpty(response.data.content)) {
                this.hasDoorPermission = false;
            }
        },
        //获取当前日期
        getNowDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return year + '-' + month + '-' + day;
        },
        //角色类型选择
        onChangeRoleType(val, flag) {
            this.roleTypeList.forEach(roleType => {
                if (roleType.iTypeId == val) {
                    this.role = roleType;
                }
            });
            if (this.role.iTypeId == 2) {
                this.isDoorType = true;
            } else {
                this.isDoorType = false;
            }
            this.transferTitle = this.role.sTypeTitle;
            this.isMenuManager = this.role.iMenuManager == 1 ? true : false;
            this.isManageRes = this.role.iResManager == 1 ? true : false;
            this.isAllowAccess = this.role.iShowUse == 1 ? true : false;
            this.isUnAllowAccess = this.role.iShowUnuse == 1 ? true : false;
            this.allowResGroup = this.role.iResGroup == 1 ? true : false;
            this.interfaceName.query = this.role.sTypeApi;
            this.interfaceName.search = this.role.sPageApi;

            if (!this.isMenuManager) {
                this.activeName = 'authTriming';
                this.$refs.authTabs.$children[0].$refs.tabs[0].style.display = 'none';
            }
            //查询微调框左侧数据
            if (this.isAllowAccess && !flag) {
                this.allowAccessData = [];
                this.$refs.allowTransfer.resetRightKeys();
                this.$refs.allowTransfer.queryDataByType();
            }
            if (this.isUnAllowAccess && !flag) {
                this.unAllowAccessData = [];
                this.$refs.unAllowTransfer.resetRightKeys();
                this.$refs.unAllowTransfer.queryDataByType();
            }
        },
        initCheckStateMap(map, checkAuth) {
            map.forEach((value, key) => {
                this.initCheckState(value, checkAuth);
                //解决操作权限有三层以上父结构勾选权限 初始化父节点不勾选问题
                this.initRootCheckState(value);
            });
        },
        getCheckMenuAuthList(resId, authList) {
            let menuAuthList = [];
            this.menuCheckedAuthList.map(item => {
                if (item.resId == resId) {
                    menuAuthList.push(item.authId);
                }
            });
            let checkedAuthList = [];
            if (!this.$util.isEmpty(this.clickCollapse) && !this.$util.isEmpty(this.clickCollapse[resId])) {
                let tempObjList = this.$util.clone(this.clickCollapse[resId].checkList);
                let tempCheckList = [];
                for (let i = 0; i < tempObjList.length; i++) {
                    const element = tempObjList[i].split(',')[1];
                    tempCheckList.push(element);
                }
                menuAuthList = tempCheckList;
            }
            //过滤权限微调中没有的菜单操作权限
            if (this.$util.isArray(menuAuthList) && menuAuthList.length > 0) {
                for (let j = 0; j < menuAuthList.length; j++) {
                    const checkAuth = menuAuthList[j];
                    for (let i = 0; i < authList.length; i++) {
                        const allAuth = authList[i];
                        if (checkAuth == allAuth.authId) {
                            checkedAuthList.push(checkAuth);
                        }
                    }
                }
            }
            return checkedAuthList;
        },

        initCheckState(list, checkAuth) {
            // 初始化默认选中状态
            for (let j in list) {
                let element = list[j];
                element.checkList = new Array();
                for (let i = 0; i < checkAuth.length; i++) {
                    if (element.resId === checkAuth[i].resId) {
                        let checkObj = {};
                        checkObj = checkAuth[i].resId + ',' + checkAuth[i].authId;
                        element.checkList.push(checkObj);
                        if (!this.$util.isEmpty(element.authTypes) && element.checkList.length === element.authTypes.length) {
                            element.checkAll = true;
                            //有全选后更改父级节点状态
                            this.changeParentState(element.sParentId, 3, true);
                        }
                    }
                }
                this.initCheckState(element.children, checkAuth);
            }
        },
        initRootCheckState(list) {
            for (let j in list) {
                let element = list[j];
                let flagCheckAll = true;
                if (this.$util.isArray(element.children) && element.children.length > 0) {
                    for (let k = 0; k < element.children.length; k++) {
                        const elementChild = element.children[k];
                        if (this.$util.isEmpty(elementChild) || !elementChild.checkAll) {
                            flagCheckAll = false;
                            break;
                        }
                    }
                } else {
                    flagCheckAll = false;
                }
                if (flagCheckAll) {
                    element.checkAll = true;
                }
            }
        },
        changeParentState(sParentId, state, val) {
            this.menuAuthMap.forEach(value => {
                this.queryObjectByResId(value, sParentId);
            });
            this.setCheckAllBtn(this.initObject, sParentId, state, val);
        },
        //查询出资源id为某个值的对象
        queryObjectByResId(list, resId) {
            // 由for in 循环方式改为以下,解决执法监督引入ofd组件，循环遍历到原型链问题
            //使用Object.keys(list).forEach方式或者用hasOwnProperty方法判断
            // for (let i in list) {
            //     if (!list.hasOwnProperty(i)) {
            //         break;
            //     }
            // doSometing();
            let _this = this;
            Object.keys(list).forEach(function(key) {
                let obj = list[key];
                if (obj.resId == resId) {
                    _this.initObject = obj;
                    return;
                }
                if (obj.children.length > 0) {
                    _this.queryObjectByResId(obj.children, resId);
                }
            });
        },
        setCheckAllBtn(obj, sParentId, state, val) {
            if (obj.resId === sParentId) {
                //当前check组全选，需要判断是否所有都全选，是则将父节点置为全选
                //当前check组全不选，需要判断是否所有都全不选，是则将父节点置为非选中
                if (obj.children) {
                    if (obj.children.length > 0) {
                        let result = { all: true, none: true, state: 1 };
                        result = this.getCheckedStatus(obj, result);
                        state = result.state;
                    }
                }
                if (obj.authTypes) {
                    if (obj.authTypes.length !== obj.checkList.length) {
                        state = 2;
                    }
                }
                if (state === 1) {
                    obj.checkAll = false;
                } else if (state === 2) {
                    obj.checkAll = false;
                } else {
                    obj.checkAll = true;
                }
            } else {
                if (Array.isArray(obj.children) && obj.children.length > 0) {
                    obj.children.forEach(element => {
                        this.setCheckAllBtn(element, sParentId, state, val);
                    });
                }
            }
        },
        getCheckedStatus(obj, res) {
            let result = res;
            for (let index = 0; index < obj.children.length; index++) {
                const element = obj.children[index];
                if (element.checkAll !== true) {
                    result.all = false;
                    //如果节点还有子菜单，继续判断
                    if (element.children.length > 0) {
                        result = this.getCheckedStatus(element, result);
                    }
                }
                //当前选中列表不为空，则不是全不选状态
                if (element.checkList && element.checkList.length > 0) {
                    result.none = false;
                }
            }
            if (result.all) {
                result.state = 3;
            } else {
                if (result.none) {
                    result.state = 1;
                } else {
                    result.state = 2;
                }
            }
            return result;
        },
        getMenuUrl() {
            let arr = this.sysList;
            this.hostUrl = '';
            let menuUrl = '';
            let orgUrl = '';
            for (let index in arr) {
                if (arr[index].sSysFlg === this.sysFlg) {
                    menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    orgUrl = arr[index].sDeptUrl;
                }
            }
            if (orgUrl === '') {
                this.orgInitFlg = false;
            }
            let param = {
                url: this.hostUrl,
                menuUrl: menuUrl,
                token: sessionStorage.getItem('token'),
                sPlatformFlg: window.app.sPlatformFlg
            };
            if (menuUrl !== '') {
                let _this = this;
                resourceApi.getMenuList(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$log.error(this.hostUrl + menuUrl, response.data.statusMessage);
                        this.hasMenuPermission = false;
                        return;
                    }
                    _this.menuList = response.data.content;
                    if (sessionStorage.getItem('userId') == 'admin') {
                        let others = {
                            menuId: 'others',
                            menuName: '其他',
                            children: [],
                            menuSort: 1000
                        };
                        _this.menuList.push(others);
                    }
                    let param = {
                        roleId: this.editItem.roleId,
                        rootFlg: 'true',
                        menuType: '3000'
                    };
                    if (!this.isAddData) {
                        resourceApi.getCheckedRoleMenu(JSON.stringify(param), response => {
                            if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('role/getCheckedRoleMenu', response.data.statusMessage);
                                return;
                            }
                            let dataList = [];
                            let menus = response.data.content;
                            let _this = this;
                            for (let i in menus) {
                                //过滤非叶子节点
                                _this.getAllNode(_this.menuList, false);
                                let data = this.allNodeMap.get(menus[i].sResId);
                                if (data !== undefined && !_this.$refs.menuTree.isHasChild(data)) {
                                    dataList.push(menus[i].sResId);
                                }
                            }
                            _this.$nextTick(function() {
                                _this.$refs.menuTree.defaultSelect(dataList);
                                _this.collapseloading = false;
                            });
                        });
                    }
                });
            }
        },

        /*  获取当前树形节点*/
        getAllNode(treeDataList, isNodeId) {
            for (let i in treeDataList) {
                let data = treeDataList[i];
                if (isNodeId) {
                    this.allNodeIdList.push(data[this.defaultProps.id]);
                } else {
                    this.allNodeMap.set(data[this.defaultProps.id], data);
                }
                if (this.$refs.menuTree.isHasChild(data)) {
                    this.getAllNode(data[this.defaultProps.children], isNodeId);
                }
            }
        },
        getCheckedDoor() {
            if (this.editItem.roleType === window.authCommon.roleType.doorAuthGroup) {
                let param = {
                    roleId: this.editItem.roleId,
                    rootFlg: 'true',
                    menuType: '12014'
                };
                resourceApi.getCheckedRoleMenu(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('role/getCheckedRoleMenu', response.data.statusMessage);
                        return;
                    }
                    let dataList = [];
                    let resList = response.data.content;
                    for (let i in resList) {
                        dataList.push(resList[i].sResId);
                    }
                    resourceApi.getDeviceTreeNodeID(JSON.stringify(dataList), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('device/getDeviceTreeNodeID', response.data.statusMessage);
                            return;
                        }
                        let doorCheckedList = response.data.content;
                        let checkedNodesList = [];
                        for (let id of doorCheckedList) {
                            let tmp = {
                                id: id,
                                sId: id.split('_')[1]
                            };
                            checkedNodesList.push(tmp);
                        }
                        let _this = this;
                        _this.$nextTick(function() {
                            _this.$refs.doorTree.setCheckedNodes(checkedNodesList);
                        });
                    });
                });
            }
        },
        getCheckedAuth(data) {
            let resId = data.resId;
            let resObj = {
                resId: resId,
                optionFlg: false
            };
            if (this.resIdList.indexOf(resObj) === -1) {
                this.resIdList.push(resObj);
            }
        },
        //获取所有选中的权限集合
        getAllCheckedResAuth(map) {
            map.forEach(value => {
                this.getCheckedResList(value);
            });
        },
        //获取选中的资源权限
        getCheckedResList(list) {
            let resultList = this.checkedResAuthList;
            for (let i in list) {
                let obj = list[i];
                if (Array.isArray(obj.checkList)) {
                    for (let j in obj.checkList) {
                        if (resultList.indexOf(obj.checkList[j]) == -1) {
                            resultList.push(obj.checkList[j]);
                        }
                    }
                }
                if (obj.children) {
                    this.getCheckedResList(obj.children, resultList);
                }
            }
        },
        //获取权限与菜单的关系Map(menuIdm,selectedAuthIdList)
        getAllResAuthMap(map) {
            map.forEach((value, key) => {
                let tempList = [];
                this.getResList(value, tempList);
                this.selectAuthMap.set(key, tempList);
            });
        },
        getResList(list, resultList) {
            if (resultList == null) {
                resultList = [];
            }
            for (let i in list) {
                let obj = list[i];
                if (Array.isArray(obj.authTypes)) {
                    for (let j in obj.authTypes) {
                        resultList.push(obj.authTypes[j].authId);
                    }
                }
                if (obj.children) {
                    this.getResList(obj.children, resultList);
                }
            }
        },
        // 初始化编辑数据
        initEditData() {
            this.formRoleInfo.roleId = this.editItem.roleId;
            this.formRoleInfo.roleName = String(this.editItem.roleName);

            this.formRoleInfo.description = String(this.editItem.roleDescription);
            this.formRoleInfo.startTime = this.editItem.startTime;
            this.formRoleInfo.endTime = this.editItem.endTime;
            this.formRoleInfo.sysFlg = this.sysFlg;
            this.formRoleInfo.roleType = this.editItem.roleType;

            this.formRoleInfo.isAntiSneak = this.editItem.isAntiSneak;
            this.formRoleInfo.isPasswordNeeded = this.editItem.isPasswordNeeded;
            this.collapseloading = false;
        },

        transData(a, idStr, pidStr, chindrenStr) {
            let r = [];
            let hash = {};
            let id = idStr;
            let pid = pidStr;
            let children = chindrenStr;
            let i = 0;
            let j = 0;
            let len = a.length;
            for (; i < len; i++) {
                hash[a[i][id]] = a[i];
            }
            for (; j < len; j++) {
                let aVal = a[j];
                let hashVP = hash[aVal[pid]];
                if (hashVP) {
                    !hashVP[children] && (hashVP[children] = []);
                    hashVP[children].push(aVal);
                } else {
                    r.push(aVal);
                }
            }
            return r;
        },
        transData1(a, idStr, pidStr, authId, chindrenStr) {
            let r = [];
            let hash = {};
            let id = idStr;
            let pid = pidStr;
            let children = chindrenStr;
            let i = 0;
            let j = 0;
            let len = a.length;
            // let authGroupTemp = 0
            for (; i < len; i++) {
                hash[a[i][id]] = a[i];
            }
            for (; j < len; j++) {
                let aVal = a[j];
                // let aaa = ''
                let hashVP = hash[aVal[pid]];

                if (hashVP) {
                    !hashVP[children] && (hashVP[children] = []);
                    hashVP[children].push(aVal);
                } else {
                    r.push(aVal);
                }
            }
            // let res = []
            let hashRes = {};
            for (let k = 0; k < r.length; k++) {
                hashRes[r[k][id]] = r[k];
            }
            return hashRes;
        },
        transData2(a, resId, pidStr, authIds, chindrenStr) {
            let r = [];
            let rid = resId;
            let aId = authIds;
            let children = chindrenStr;

            let len = a.length;
            for (let i = 0; i < len; i++) {
                let aValOut = a[i];
                for (let j = 0; j < len; j++) {
                    // let aVal = a[j]
                    let aVal = {};
                    aVal.authName = a[j]['authName'];
                    aVal.authId = a[j]['resId'] + ',' + a[j][aId];
                    aVal.iDelFlg = 0;
                    aVal.resName = '';
                    aVal.resId = a[j]['resId'] + a[j][aId];
                    aVal.sParentId = '';
                    if (a[j][aId] !== 0 && a[j][aId] !== '' && a[j][rid] === a[i][rid]) {
                        !aValOut[children] && (aValOut[children] = []);
                        aValOut[children].push(aVal);
                    }
                }
                r.push(aValOut);
            }
            let hashRes = {};
            for (let k = 0; k < r.length; k++) {
                hashRes[r[k][rid]] = r[k];
            }
            let arr = [];
            for (let i in hashRes) {
                arr.push(hashRes[i]); // 属性
            }
            return arr;
        },
        // 提交数据
        submitForm(formName) {
            let _this = this;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let resAuthlistArr = [];
                    this.checkedResAuthList = [];
                    //获取选中资源权限
                    this.getAllCheckedResAuth(this.menuAuthMap);
                    resAuthlistArr = this.checkedResAuthList;
                    const menuType = '3000';
                    const doorType = '12014';
                    // ES6牛逼方法，不兼容IE。。。暂时放弃
                    // let newarr = Array.from(new Set(this.checkedList))
                    let menuIdList = '';
                    if (this.normalRole || this.isOrgType) {
                        let menuIdArr = _this.$refs.menuTree.getCheckedKeys();
                        if (menuIdArr.length > 0) {
                            menuIdList = menuIdArr.join('|');
                        }
                        let menuRootNodes = this.$refs.menuTree.getHalfCheckedNodes();
                        // let menuRootIds = []
                        for (let index = 0; index < menuRootNodes.length; index++) {
                            let element = menuRootNodes[index];
                            menuIdList += '|' + element.menuId;
                        }
                    }
                    let doorIdList = [];
                    let resIdArr = [];
                    let resArr = this.resIdList;
                    for (let index = 0; index < resArr.length; index++) {
                        let element = resArr[index];
                        if (element.optionFlg === true) {
                            resIdArr.push(element.resId);
                        }
                    }
                    //校验允许访问的资源与禁止访问的资源是否重复
                    let allow = this.$refs.allowTransfer.getAllRightKeys();
                    let unAllow = this.$refs.unAllowTransfer.getAllRightKeys();
                    for (let i = 0; i < allow.length; i++) {
                        for (let j = 0; j < unAllow.length; j++) {
                            if (allow[i].sResId == unAllow[j].sResId) {
                                this.$message({ showClose: true, message: this.$t('role.ALLOW_UNALLOW_HAS_REAPEAT_DATA'), type: 'warning' });
                                this.loading = false;
                                return;
                            }
                        }
                    }
                    let content = {
                        startTime: this.formRoleInfo.startTime,
                        endTime: this.formRoleInfo.endTime,
                        sysFlg: this.sysFlg,
                        roleName: this.formRoleInfo.roleName,
                        roleDescription: this.formRoleInfo.description,
                        roleId: this.formRoleInfo.roleId,
                        resId: this.formRoleInfo.resId,
                        resIdList: resIdArr.join(','),
                        resAuthList: resAuthlistArr.join('|'),
                        useResAuthList: allow,
                        unUseResAuthList: unAllow,
                        menuIds: menuIdList,
                        menuType: menuType,
                        doorIds: doorIdList.join('|'),
                        doorType: doorType,
                        doorScheduleId: 'defaultDoorScheduleId',
                        isAntiSneak: this.formRoleInfo.isAntiSneak,
                        isPasswordNeeded: this.formRoleInfo.isPasswordNeeded,
                        roleType: this.formRoleInfo.roleType,
                        hasMenuPermission: this.hasMenuPermission,
                        hasOrgPermission: this.hasOrgPermission,
                        rightDataFinetune: this.checkedAuthTriming
                    };
                    if (this.isAddData) {
                        resourceApi.insertRoleInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('role/insertRoleInfo', response.data.statusMessage);
                                this.loading = false;
                                return;
                            }
                            this.loading = false;
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.roleDialogClose();
                            this.$emit('submit');
                        });
                    } else {
                        content.resId = this.editItem.resId;
                        resourceApi.updateRoleInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('role/updateRoleInfo', response.data.statusMessage);
                                this.loading = false;
                                return;
                            }
                            this.loading = false;
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.roleDialogClose();
                            this.$emit('submit');
                        });
                    }
                }
                // }
            });
        },
        // 关闭窗口之前需要调用的方法
        roleDialogClose() {
            this.$emit('roleDialogClose');
            this.$refs['formRoleInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style scoped>
>>> .el-collapse-item__content {
    padding-bottom: 0px;
}
>>> .el-table td {
    border-right: 0px;
}
>>> i.iconfont.icongongju {
    margin-left: -5px;
}
>>> .tree_aollapse_node span {
    display: inherit !important;
}
>>> span.span-ellipsis {
    width: 150px !important;
}
.el-collapse {
    margin-top: 15px;
}
>>> .el-table:before {
    height: 0px !important;
}
</style>
